import { createComponentStore } from '../../utils/createComponentStore';

const emptyTemplateData = () => ({
  targetProjectId: '',
  targetComponentId: '',
  savedPlaceholders: [],
});

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'trigger_another_workflow',
  endpoint: 'triggerAnotherWorkflow',
  registryKey: 'triggerAnotherWorkflow',
  initData: emptyTemplateData,

  onLoadData: (rawData, component) => {
    const cd = component.componentData;
    return {
      ...emptyTemplateData(),
      targetProjectId: rawData.targetProjectId ?? cd.targetProjectId ?? '',
      targetComponentId: rawData.targetComponentId ?? cd.targetComponentId ?? '',
      savedPlaceholders: [...(rawData.savedPlaceholders ?? cd.savedPlaceholders ?? [])],
      ...rawData,
    };
  },

  extraActions: (set, get) => ({
    // Backward-compat alias
    setTriggerAnotherWorkflowTemplate: (component) => get().setComponentData(component),

    // Alias for setName
    setTriggerAnotherWorkflowName: (name) => get().setName(name),
  }),
});

export function getTriggerAnotherWorkflowStore(componentId) {
  return getStore(componentId);
}

export default defaultStore;
